import { Button } from "flowbite-react";
import { ArrowLeft } from "@phosphor-icons/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const NoCampaignData: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const pathName = useLocation().pathname.split("/")[1];

  return (
    <div className="flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-400 mb-4">
          📊
        </h1>
        <h2 className="text-2xl font-bold text-gray-900 mt-4 mb-6">
          {t("common.noCampaignData")}
        </h2>
        <div className="flex justify-center">
          <Button
            color="light"
            onClick={() => navigate(pathName === "apps" ? "/apps" : "/app-country-reports")}
            className="flex items-center"
          >
            <ArrowLeft className="mr-2 h-5 w-5" />
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoCampaignData; 